import { render, staticRenderFns } from "./TransferUSDT.vue?vue&type=template&id=e5c34abe&scoped=true&"
import script from "./TransferUSDT.vue?vue&type=script&lang=js&"
export * from "./TransferUSDT.vue?vue&type=script&lang=js&"
import style0 from "./TransferUSDT.vue?vue&type=style&index=0&id=e5c34abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c34abe",
  null
  
)

export default component.exports